import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { ChevronRightIcon } from 'lucide-react';
const HomePage: React.FC = () => {
  return <div className="min-h-screen flex flex-col bg-gray-100" data-id="element-144">
      <Header data-id="element-145" />
      <main className="flex-grow container mx-auto px-4 py-8" data-id="element-146">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-147">
          <div className="md:flex" data-id="element-148">
            <div className="md:flex-1 p-8" data-id="element-149">
              <h1 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-150">
                Avaliador de Pão Tipo Francês
              </h1>
              <h2 className="text-xl text-orange-500 font-semibold mb-6" data-id="element-151">
                ABNT NBR 16170
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-152">
                Bem-vindo ao sistema de avaliação de pão tipo francês baseado na
                norma ABNT NBR 16170. Esta ferramenta permite avaliar a
                qualidade e conformidade do pão francês de acordo com os
                critérios estabelecidos pela Associação Brasileira de Normas
                Técnicas.
              </p>
              <p className="text-gray-600 mb-8" data-id="element-153">
                Através desta aplicação, você poderá avaliar 13 atributos
                diferentes do pão francês, obter uma classificação automática da
                qualidade e gerar relatórios detalhados para controle interno de
                qualidade da sua padaria.
              </p>
              <Link to="/evaluation" className="inline-flex items-center bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-lg transition duration-200" data-id="element-154">
                Vamos começar a avaliação
                <ChevronRightIcon className="ml-2" size={20} data-id="element-155" />
              </Link>
            </div>
            <div className="md:flex-1 bg-orange-50 flex items-center justify-center p-6" data-id="element-156">
              <div className="w-full h-full" data-id="element-157">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nPhDYMHhkoV2zne9cD4it1/padeiro.jpg" alt="Padeiro com Pão Francês" className="rounded-lg shadow-md w-full h-full object-cover" data-id="element-158" />
              </div>
            </div>
          </div>
        </div>
        <footer className="mt-12 text-center text-gray-500 text-sm" data-id="element-159">
          <p data-id="element-160">Baseado na norma ABNT NBR 16170</p>
          <p data-id="element-161">Em parceria com Sebrae</p>
          <p data-id="element-162">Versão 1.0</p>
        </footer>
      </main>
    </div>;
};
export default HomePage;